export default "/_next/static/videos/pleo-about-us-short.mp4";